import * as dateFns from 'date-fns';

const DEFAULT_DATE_FORMAT = 'MMMM dd, yyyy';
const REWARD_GAP_DAYS = 120;

export const format = (date: Date) => dateFns.format(date, DEFAULT_DATE_FORMAT);

export const getFormattedRewardDates = (dateStartUnix: number) => {
  const dateStartDate = dateFns.fromUnixTime(dateStartUnix);

  return [format(dateStartDate), format(dateFns.add(dateStartDate, { days: REWARD_GAP_DAYS }))];
};
